<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo_name">桥隧设施智能动态监管平台</div>
        <div class="home_top_nav content_nav">
            <span @click="backSuidaoIndex()"><i class="el-icon-s-home"></i>一网统管</span>
            <span class="home_line"></span>
            <span @click="qiaosuiManager"><i class="el-icon-coin"></i>桥隧管理</span>
            <span class="home_line"></span>
            <span><i class="iconfont icon-yonghu"></i>用户管理</span>
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img src="../../assets/img/img.jpg" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{username}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <span class="home_line line_height"></span>
                <img src="../../assets/img/message.png" class="u_message" />
                <span class="home_line line_height"></span>
                <img src="../../assets/img/off.png" class="u_message" />
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            name: 'admin',
            message: 2
        };
    },
    computed: {
        username() {
            let username = localStorage.getItem('ms_username');
            return username ? username : this.name;
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                localStorage.removeItem('ms_username');
                this.$router.push('/login');
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 返回项目列表
        backSuidaoIndex: function () {
            this.$router.push(`/bridgeTunnelIndex`)
        },
        qiaosuiManager(){
            this.$router.push('/bridgeSurvey')
        }
    }
};
</script>